const fetcher = async (url: string, config: Partial<RequestInit> = {}) => {
  const response = await fetch(url, config);

  return response.json();
};

export default fetcher;
